module.exports = "/*@media (max-width: 767px) {  \n  .body-content {\n    padding-top: 50px;\n  }\n}*/\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = ./src/app/app.component.css
// module chunks = main